import CHARACTER_GENERATION_PARAM_COLLECTION_DEFAULT from './../constants/CHARACTER_GENERATION_PARAM_COLLECTION_DEFAULT'

export default {
  sideCharacterIdList : [],
  characterCollection : {},
  heroGenerationParamCollection: CHARACTER_GENERATION_PARAM_COLLECTION_DEFAULT,
}
